import { render, staticRenderFns } from "./consultations.vue?vue&type=template&id=2b829264&"
import script from "./consultations.vue?vue&type=script&lang=js&"
export * from "./consultations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports